<script lang="ts">
  import { Translations } from '../translations';
  import { fade } from 'svelte/transition';
  import { onMount } from "svelte";

  export let translations: Translations;
  export let flow: number;
  export let email: string = "";  
  export let password: string = "";

  let passwordControl: any;
  
  onMount(async () => {
    let i18n = {
      "errorMessage": translations.get("Some error occurred"),
      "successLabel": translations.get("Success"),
      "revealPasswordText": translations.get("Show"),
      "hidePasswordText": translations.get("Hide")
    };
    
    passwordControl.i18n = i18n;
  })  
</script>

<style lang="scss">
  .wk-padding-top-1 {
    padding-top: 1rem;
  }
  .wk-padding-top-2 {
    padding-top: 2rem;
  }
</style>


<div in:fade>
  <div class="wk-grid">
    <p>{@html translations.get("From now on you only need <b>your e-mail address and your password</b> to log in.")}</p>
  </div>
  <div class="wk-grid">
    <p class="wk-weight-500 wk-padding-top-2">{translations.get("Your new login details")}</p>
  </div>
  <div class="wk-grid">
    <wk-input label='{translations.get("E-Mail")}' class="wk-column-6" type-class="wk-field-small">
      <input class="wk-field-input"
             autocomplete="username"
             type='text'
             placeholder='{translations.get("Please enter your email")}'
             name='Email'
             maxlength="255"
             required
             readonly={true}
             bind:value={email}/>
    </wk-input>
    <wk-password-input label='{translations.get("Password")}' bind:this={passwordControl} class="wk-column-6" type-class="wk-field-small">
      <input class="wk-field-input"
             id="invitation-form-input-password"
             autocomplete="new-password"
             type='password'
             name='Password'
             required
             readonly={true}
             bind:value={password} />
    </wk-password-input>
  </div>
  {#if flow === 1}
  <div class="wk-notification wk-is-open wk-notification-warning wk-padding-top-1" role="alert">
    <span class="wk-icon-filled-caution" aria-hidden="true"></span>
    <p class="wk-notification-content">{translations.get("Your previous login details are no longer valid.")}</p>
  </div>
  {/if} 
</div>